import { render, staticRenderFns } from "./MultiVpc.vue?vue&type=template&id=30e6842a"
import script from "./MultiVpc.vue?vue&type=script&lang=ts"
export * from "./MultiVpc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports